import { ReactComponent as LogoImagic } from "../assets/logo-imagic.svg";

export default LogoImagic;
